var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ClientMain"},[_c('ClientHeader'),_c('div',{staticClass:"Reference"},[_c('h2',{staticClass:"NameOfServise"},[_vm._v("Сервис доставки еды")]),_c('div',{staticClass:"ReferenceMainframe"},[(_vm.flag)?_c('ChooseStationForm'):_vm._e()],1)]),_c('div',{staticClass:"Footer"},[_c('ClientFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }